export interface AgentCompetency {
  id: string;
  name: string;
  description: string;
  icon: string;
  color: string;
}

export const agentCompetencies: AgentCompetency[] = [
  {
    id: "deployment",
    name: "Deployment Agents",
    description:
      "Automate application and infrastructure deployment across environments with zero-downtime strategies.",
    icon: "Zap",
    color: "orange-500",
  },
  {
    id: "monitoring",
    name: "Monitoring Agents",
    description:
      "Intelligent monitoring, alerting, and self-healing capabilities for infrastructure health.",
    icon: "Monitor",
    color: "blue-500",
  },
  {
    id: "security",
    name: "Security Agents",
    description:
      "Automated security scanning, vulnerability assessment, and compliance enforcement.",
    icon: "Lock",
    color: "red-500",
  },
  {
    id: "cost-optimization",
    name: "Cost Optimization",
    description:
      "Resource optimization, cost analysis, and automated right-sizing for cloud efficiency.",
    icon: "BarChart3",
    color: "green-500",
  },
  {
    id: "database",
    name: "Database Agents",
    description:
      "Database provisioning, migration, backup automation, and performance optimization.",
    icon: "Database",
    color: "purple-500",
  },
  {
    id: "network",
    name: "Network Agents",
    description:
      "Network configuration, VPN setup, load balancer management, and traffic optimization.",
    icon: "Network",
    color: "indigo-500",
  },
  {
    id: "container",
    name: "Container Agents",
    description:
      "Container orchestration, Kubernetes cluster management, and containerized workloads.",
    icon: "Server",
    color: "cyan-500",
  },
  {
    id: "cicd",
    name: "CI/CD Agents",
    description:
      "Continuous integration, deployment pipelines, and automated testing workflows.",
    icon: "GitBranch",
    color: "orange-600",
  },
  {
    id: "cloud-platform",
    name: "Cloud Platform Agents",
    description:
      "Multi-cloud management, cloud migration, and platform-specific automation.",
    icon: "Cloud",
    color: "sky-500",
  },
  {
    id: "serverless",
    name: "Serverless Agents",
    description:
      "Function-as-a-Service deployment, event-driven architectures, and serverless workflows.",
    icon: "Zap",
    color: "yellow-500",
  },
  {
    id: "storage",
    name: "Storage Agents",
    description:
      "Storage provisioning, backup automation, data archiving, and storage optimization.",
    icon: "Server",
    color: "teal-500",
  },
  {
    id: "iac",
    name: "IaC Agents",
    description:
      "Terraform, CloudFormation, and infrastructure code generation and management.",
    icon: "Code2",
    color: "slate-500",
  },
  {
    id: "disaster-recovery",
    name: "Disaster Recovery",
    description:
      "Backup strategies, failover automation, and business continuity planning.",
    icon: "Shield",
    color: "emerald-500",
  },
  {
    id: "performance",
    name: "Performance Agents",
    description:
      "Performance tuning, load testing, capacity planning, and resource optimization.",
    icon: "Cpu",
    color: "pink-500",
  },
  {
    id: "multi-cloud",
    name: "Multi-Cloud Agents",
    description:
      "Cross-cloud deployment, hybrid cloud management, and cloud vendor abstraction.",
    icon: "Globe",
    color: "violet-500",
  },
  {
    id: "collaboration",
    name: "Collaboration Agents",
    description:
      "Team workflow automation, approval processes, and infrastructure governance.",
    icon: "Users",
    color: "rose-500",
  },
  {
    id: "api-management",
    name: "API Management Agents",
    description:
      "API gateway configuration, rate limiting, authentication, and API lifecycle management.",
    icon: "Settings",
    color: "amber-500",
  },
  {
    id: "backup-archive",
    name: "Backup & Archive Agents",
    description:
      "Automated backup scheduling, data archiving, retention policies, and restore automation.",
    icon: "Archive",
    color: "slate-600",
  },
];

// Helper function to get competency names for forms and filtering
export const getCompetencyNames = (): string[] => {
  return agentCompetencies.map((competency) => competency.name);
};

// Helper function to get competency by ID
export const getCompetencyById = (id: string): AgentCompetency | undefined => {
  return agentCompetencies.find((competency) => competency.id === id);
};

// Helper function to get competency by name
export const getCompetencyByName = (
  name: string,
): AgentCompetency | undefined => {
  return agentCompetencies.find((competency) => competency.name === name);
};
